// @flow
import WebComponent from '../webComponents/WebComponent';

class RadioSelect extends WebComponent {
  constructor(props) {
    super(props);
    this.handleInnerInputsChange = this.handleInnerInputsChange.bind(this);
  }
  enterDocument() {
    this.on('change', 'input', this.handleInnerInputsChange);
  }
  handleInnerInputsChange(e) {
    e.stopPropagation();
    this.dispatchChangeEvent();
  }
}
export default RadioSelect;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RadioSelect.js